import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Admin from "./components/Admin";
import PrivateRoute from "./components/PrivateRoute";
import AdminPrivateRoute from "./components/AdminPrivateRoute";

import ChangePassword from "./components/ChangePassword";
import ForgotCredentials from "./components/ForgotCredentials";

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot" element={<ForgotCredentials />} />
      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/license/*"
        element={
          <AdminPrivateRoute>
            <Dashboard />
          </AdminPrivateRoute>
        }
      />
    </Routes>
  </Router>
);

export default App;
